var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 97,
    viewBox: "0 0 240 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.844 21.174C206.794 21.1467 206.753 21.1056 206.726 21.0557L205 17.8999L203.274 21.0556C203.247 21.1056 203.206 21.1466 203.156 21.174L200 22.8999L203.156 24.6259C203.206 24.6532 203.247 24.6943 203.274 24.7442L205 27.8999L206.726 24.7442C206.753 24.6943 206.794 24.6532 206.844 24.6259L210 22.8999L206.844 21.174Z",
    fill: "#C4C9E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.5 1C70.6943 1 28 43.4708 28 96H219C219 43.4708 176.025 1 123.5 1V1Z",
    stroke: "#AEB3CC",
    strokeDasharray: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84436 41.174C6.79437 41.1467 6.75332 41.1056 6.72597 41.0557L5.00003 37.8999L3.27415 41.0556C3.2468 41.1056 3.20575 41.1466 3.15576 41.174L0 42.8999L3.1557 44.6259C3.20569 44.6532 3.24674 44.6943 3.27409 44.7442L4.99997 47.8999L6.72591 44.7442C6.75326 44.6943 6.79431 44.6532 6.8443 44.6259L10 42.8999L6.84436 41.174Z",
    fill: "#C4C9E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.844 71.174C236.794 71.1467 236.753 71.1056 236.726 71.0557L235 67.8999L233.274 71.0556C233.247 71.1056 233.206 71.1466 233.156 71.174L230 72.8999L233.156 74.6259C233.206 74.6532 233.247 74.6943 233.274 74.7442L235 77.8999L236.726 74.7442C236.753 74.6943 236.794 74.6532 236.844 74.6259L240 72.8999L236.844 71.174Z",
    fill: "#C4C9E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40.1875H155M94 60.8125H155M114.333 40.1875V78M134.667 40.1875V78M104.844 78H144.156C147.951 78 149.85 78 151.299 77.2506C152.575 76.5917 153.612 75.5398 154.261 74.2463C155 72.7757 155 70.8503 155 67V34C155 30.1497 155 28.2245 154.261 26.7538C153.612 25.4602 152.575 24.4084 151.299 23.7493C149.85 23 147.951 23 144.156 23H104.844C101.049 23 99.1506 23 97.7007 23.7493C96.4254 24.4084 95.3885 25.4602 94.7387 26.7538C94 28.2245 94 30.1496 94 34V67C94 70.8503 94 72.7757 94.7387 74.2463C95.3885 75.5398 96.4254 76.5917 97.7007 77.2506C99.1506 78 101.049 78 104.844 78Z",
    stroke: "#AEB3CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTable);
export default __webpack_public_path__ + "static/media/empty-table.82bfbeb23a3c3c36e8889793876ef5f6.svg";
export { ForwardRef as ReactComponent };